export const API_BASE_URL = "https://osint.pengawasperikanan.or.id";
// export const API_BASE_URL = "http://localhost:5000";
